import { OdometerFilter } from '../models/Filter';

export const printOdometerFilterValue = (filter: OdometerFilter, t: (...args) => string) => {
  const startValue = t('distanceWithUnit', { val: { value: filter?.start, unit: filter?.unit || 'mi' } });
  const endValue = t('distanceWithUnit', { val: { value: filter?.end, unit: filter?.unit || 'mi' } });

  switch (true) {
    case !!filter?.start && !filter?.end:
      return `> ${startValue}`;
    case !!filter?.start && !!filter?.end:
      return `${startValue}-${endValue}`;
    case !!filter?.end && !filter?.start:
      return `< ${endValue}`;
    default:
      return '';
  }
};
